module.exports = __webpack_public_path__ + "img/Logo_IIM_fd_couleur.25400098.png";